module.exports = __webpack_public_path__ + "eg.svg?1e73d42362234481a1128d3e4d2e25cb";